import { Heading, List, ListItem } from '@athena/forge';
import SuccessLarge from '@athena/forge-icons/dist/SuccessLarge';
import { ENROLLED_FACTOR_CONFIG } from '../../constants';
import { getLocalizedString } from '../../utils/i18n-utils';

export default function EnrolledFactors({
  enrolledFactors,
  title,
}: {
  enrolledFactors: [keyof typeof ENROLLED_FACTOR_CONFIG];
  title: string;
}) {
  return (
    <>
      <h3 className="fe_u_margin--bottom-large fe_u_font-weight--semibold">{title}</h3>
      <List className="fe_u_margin--bottom-large">
        {enrolledFactors.map((factor) => {
          const factorConfig = ENROLLED_FACTOR_CONFIG[factor];
          if (factorConfig) {
            return (
              <ListItem className={'fe_u_flex-container fe_u_flex-align-items--center'} key={factor}>
                <div className="authenticator-row clearfix fe_u_margin--top-small fe_u_margin--bottom-medium fe_u_margin--right-none">
                  <div className="authenticator-icon-container">
                    <div className={`factor-icon authenticator-icon ${factorConfig.iconClass}`}></div>
                  </div>
                </div>
                <Heading className="fe_u_font-size--default" text={getLocalizedString(factorConfig.labelI18nKey)} variant="subsection" />
                <div className="enrolled-factor-success-icon">
                  <SuccessLarge />
                </div>
              </ListItem>
            );
          }
          else {
            return <div key={factor}></div>;
          }
        })}
      </List>
    </>
  );
}
